<template>
  <generic-modal :modal-key="''"
                 :classStyle="'popup_box ungame_balance_popup modal_cont'"
                 :idProp="''"
                 @close="closeModal">
    <template slot="content">
      <h1>{{ getTranslations.home_modal_unlocked_zero_you_do_not}}</h1>
      <h6>{{ getTranslations.home_modal_unlocked_zero_play }}</h6>
      <img src="static/images/popups/unlocked_games_zero.png" class="ungame_bal_img">
      <p>{{ getTranslations.home_modal_unlocked_zero_unlock_more }}</p>
      <button type="" @click="toBundlesPage">{{ getTranslations.home_modal_unlocked_zero_unlock_button }}</button>
    </template>
  </generic-modal>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import GenericModal from '../../sharedcomponents/GenericModal';

export default {
  name: 'unlocked-games-zero-balance-modal',
  components: { GenericModal },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    toBundlesPage() {
      this.storeModalForHomePage(null);
      this.$router.push('/home/store');
    },
    closeModal() {
      this.storeModalForHomePage(null);
      this.saveBonusDailyModal(null);
      this.$emit('close');
    },
  },
  computed: {
    ...mapState('common', [
      'hideStore',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/unlockedgames/UnlockedGamesZeroBalanceModal.vue